import { useMutation, useQuery } from '@tanstack/react-query';

import { getInvestboxesAdministration, changeStrategy } from '../../../../api';
import { SortType } from '../../../../types/pagination';

export const useChangeState = () => useMutation({ mutationKey: ['changeStrategy'], mutationFn: changeStrategy });

export const useInvestBoxes = () =>
  useQuery({
    queryKey: ['getInvestboxesAdministration'],
    queryFn: () =>
      getInvestboxesAdministration({
        pageNumber: 0,
        pageSize: 1000,
        sortFieldName: 'name',
        sortDirection: SortType.Desk,
      }),
  });
